import { createPinia } from 'pinia'
import { createApp } from 'vue'
import {
  Alert,
  Button,
  Card,
  Checkbox,
  ConfigProvider,
  Descriptions,
  Drawer,
  Empty,
  Form,
  Input,
  InputNumber,
  Layout,
  Menu,
  Modal,
  Pagination,
  Radio,
  Result,
  Space,
  Spin,
  Statistic,
  Select,
  Tag,
} from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import App from './App.vue'
import { router } from './router/index.js'
import { useAppStore } from './stores/appStore.js'
import { useThemeStore } from './stores/themeStore.js'
import './styles/main.scss'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
for (const component of [
  Alert,
  Button,
  Card,
  Checkbox,
  ConfigProvider,
  Descriptions,
  Drawer,
  Empty,
  Form,
  Input,
  InputNumber,
  Layout,
  Menu,
  Modal,
  Pagination,
  Radio,
  Result,
  Space,
  Spin,
  Statistic,
  Select,
  Tag,
]) {
  app.use(component)
}

const appStore = useAppStore(pinia)
const themeStore = useThemeStore(pinia)
themeStore.initialize()

app.config.errorHandler = (error) => appStore.reportError(error)
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault()
    appStore.reportError(event.reason)
  })
}

void appStore.initialize()
app.mount('#app')
